import { apiRequest } from "../_core/apiRequest";
import { unwrapProfileResponse } from "./profileResponseEnvelope";

export async function changeAccountLogo(base64Image) {
  const response = await apiRequest({
    method: "put",
    path: "/profile/account-logo",
    data: { base64_image: base64Image },
    errorMessage: "Erro ao atualizar logo da conta",
  });

  return unwrapProfileResponse(response);
}
